export default __webpack_public_path__ + "static/1896-83f8f3022734d61d7327c856da51effb.gif";